export default {
    jotform__lightbox__container : {
        'a' : {
            cursor: 'pointer'
        }
    }
}